import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { removeAccountIdFromSearch } from './removeAccountIdFromSearch';

/**
 * Drops `?accountId=` from the current URL, keeping the route and every other query param.
 *
 * `?accountId=` outranks the current selection in `resolveActiveAccountId`
 * (`SmartLinksContainer`), so every place that changes the active artist — the switcher's
 * `onSelect` and `AddArtistModal`'s create — must call this right after dispatching
 * `setAccountId`, or the resolver reads the stale id back out of the URL on the next render and
 * switches straight back. One shared hook so a future caller cannot miss the step.
 */
export function useDropAccountIdFromUrl(): () => void {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(() => {
    const nextSearch = removeAccountIdFromSearch(location.search);
    if (nextSearch !== location.search) {
      // eslint-disable-next-line no-void
      void navigate({ pathname: location.pathname, search: nextSearch }, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);
}
